// we want the yaml generated to be in the order we describe
/* eslint-disable sort-keys-fix/sort-keys-fix */

import { platformListTables } from 'shared/base';
import { fetchAllPages } from 'shared/base/utils/api';

import { ReportYamlItem } from '@/components/reports/types/report';

const certificatesEmptyQuery = `
    SELECT
      '' as cloud,
      '' as account,
      '' as resource_type,
      '' as name,
      now() as expiration_date,
      '' as tags
    LIMIT 0
`;

const getExpiredCertificatesQuery = (tables: string[]) => {
  const tableToSelect = [
    {
      select: `_cq_cloud, _cq_account, _cq_account_name, _cq_name, _cq_id, 'gcp_appengine_authorized_certificates' as resource_type, tags, expire_time AS expiration_date FROM gcp_appengine_authorized_certificates`,
      table: 'gcp_appengine_authorized_certificates',
    },
    {
      select: `_cq_cloud, _cq_account, _cq_account_name, _cq_name, _cq_id, 'gcp_applicationintegration_certificates' as resource_type, tags, valid_end_time AS expiration_date FROM gcp_applicationintegration_certificates`,
      table: 'gcp_applicationintegration_certificates',
    },
    {
      select: `_cq_cloud, _cq_account, _cq_account_name, _cq_name, _cq_id, 'gcp_compute_ssl_certificates' as resource_type, tags, toDateTime(parseDateTimeBestEffort(expire_time)) AS expiration_date FROM gcp_compute_ssl_certificates`,
      table: 'gcp_compute_ssl_certificates',
    },
    {
      select: `_cq_cloud, _cq_account, _cq_account_name, _cq_name, _cq_id, 'gcp_certificatemanager_certificates' as resource_type, tags, expire_time AS expiration_date FROM gcp_certificatemanager_certificates`,
      table: 'gcp_certificatemanager_certificates',
    },
    {
      select: `_cq_cloud, _cq_account, _cq_account_name, _cq_name, _cq_id, 'aws_acm_certificates' as resource_type, tags, not_after AS expiration_date FROM aws_acm_certificates`,
      table: 'aws_acm_certificates',
    },
    {
      select: `_cq_cloud, _cq_account, _cq_account_name, _cq_name, _cq_id, 'aws_apigateway_client_certificates' as resource_type, tags, expiration_date AS expiration_date FROM aws_apigateway_client_certificates`,
      table: 'aws_apigateway_client_certificates',
    },
    {
      select: `_cq_cloud, _cq_account, _cq_account_name, _cq_name, _cq_id, 'aws_dms_certificates' as resource_type, tags, valid_to_date AS expiration_date FROM aws_dms_certificates`,
      table: 'aws_dms_certificates',
    },
    {
      select: `_cq_cloud, _cq_account, _cq_account_name, _cq_name, _cq_id, 'aws_docdb_certificates' as resource_type, tags, valid_till AS expiration_date FROM aws_docdb_certificates`,
      table: 'aws_docdb_certificates',
    },
    {
      select: `_cq_cloud, _cq_account, _cq_account_name, _cq_name, _cq_id, 'aws_iam_server_certificates' as resource_type, tags, expiration AS expiration_date FROM aws_iam_server_certificates`,
      table: 'aws_iam_server_certificates',
    },
    {
      select: `_cq_cloud, _cq_account, _cq_account_name, _cq_name, _cq_id, 'aws_lightsail_load_balancer_tls_certificates' as resource_type, tags, not_after AS expiration_date FROM aws_lightsail_load_balancer_tls_certificates`,
      table: 'aws_lightsail_load_balancer_tls_certificates',
    },
    {
      select: `_cq_cloud, _cq_account, _cq_account_name, _cq_name, _cq_id, 'aws_lightsail_load_balancer_tls_certificates' as resource_type, tags, revoked_at AS expiration_date FROM aws_lightsail_load_balancer_tls_certificates`,
      table: 'aws_lightsail_load_balancer_tls_certificates',
    },
    {
      select: `_cq_cloud, _cq_account, _cq_account_name, _cq_name, _cq_id, 'aws_rds_certificates' as resource_type, tags, valid_till AS expiration_date FROM aws_rds_certificates`,
      table: 'aws_rds_certificates',
    },
    {
      select: `_cq_cloud, _cq_account, _cq_account_name, _cq_name, _cq_id, 'aws_lightsail_certificates' as resource_type, tags, not_after AS expiration_date FROM aws_lightsail_certificates`,
      table: 'aws_lightsail_certificates',
    },
    {
      select: `_cq_cloud, _cq_account, _cq_account_name, _cq_name, _cq_id, 'aws_transfer_certificates' as resource_type, tags, not_after_date AS expiration_date FROM aws_transfer_certificates`,
      table: 'aws_transfer_certificates',
    },
    {
      select: `_cq_cloud, _cq_account, _cq_account_name, _cq_name, _cq_id, 'azure_appservice_certificates' as resource_type, tags, toDateTime(parseDateTimeBestEffort(JSONExtractString(properties, 'expirationDate'))) AS expiration_date FROM azure_appservice_certificates`,
      table: 'azure_appservice_certificates',
    },
    {
      select: `_cq_cloud, _cq_account, _cq_account_name, _cq_name, _cq_id, 'azure_containerapps_managed_environment_certificates' as resource_type, tags, toDateTime(parseDateTimeBestEffort(JSONExtractString(properties, 'expirationDate'))) AS expiration_date FROM azure_containerapps_managed_environment_certificates`,
      table: 'azure_containerapps_managed_environment_certificates',
    },
    {
      select: `_cq_cloud, _cq_account, _cq_account_name, _cq_name, _cq_id, 'azure_containerapps_connected_environment_certificates' as resource_type, tags, toDateTime(parseDateTimeBestEffort(JSONExtractString(properties, 'expirationDate'))) AS expiration_date FROM azure_containerapps_connected_environment_certificates`,
      table: 'azure_containerapps_connected_environment_certificates',
    },
    {
      select: `_cq_cloud, _cq_account, _cq_account_name, _cq_name, _cq_id, 'azure_keyvault_certificates' as resource_type, tags, toDateTime(parseDateTimeBestEffort(JSONExtractString(attributes, 'exp'))) AS expiration_date FROM azure_keyvault_certificates`,
      table: 'azure_keyvault_certificates',
    },
  ];

  const filteredTableToSelect = tableToSelect.filter((t) => tables.includes(t.table));
  if (filteredTableToSelect.length === 0) {
    return certificatesEmptyQuery;
  }

  const resourceTypeLabelsQuery = `
    WITH resource_type_labels AS (
      SELECT resource_type_label, resource_type FROM cloud_assets
      WHERE resource_type IN (${filteredTableToSelect.map((t) => `'${t.table}'`).join(', ')})
      GROUP BY resource_type_label, resource_type
    )
  `;

  const certificateQuery = `certificates AS (
    ${filteredTableToSelect.map((t) => `SELECT ${t.select}`).join(' UNION DISTINCT ')}
  )`;

  const fullQuery = `
    ${resourceTypeLabelsQuery},
    ${certificateQuery},
    enriched_certificates AS (
      SELECT
        c._cq_cloud as cloud,
        COALESCE(NULLIF(c._cq_account_name, ''), c._cq_account) as account,
        r.resource_type_label as resource_type,
        c._cq_name as name,
        c.expiration_date as expiration_date,
        c.tags as tags,
        ROW_NUMBER() OVER (PARTITION BY c._cq_id ORDER BY c.expiration_date) as row_num
      FROM certificates c
      INNER JOIN resource_type_labels r ON r.resource_type = c.resource_type
    )
    SELECT
      cloud,
      account,
      resource_type,
      name,
      expiration_date,
      tags,
      lower(concat(
        coalesce(cloud, ''),
        coalesce(account, ''),
        coalesce(resource_type, ''),
        coalesce(name, ''),
        coalesce(tags, '')
      )) as search_string
    FROM enriched_certificates
    WHERE row_num = 1 AND expiration_date <= '?'
  `;

  return fullQuery;
};

const expiredCertificatesItem = (baseQuery: string): ReportYamlItem => {
  return {
    title: 'Expiring / Expired SSL Certificates',
    display: {
      type: 'table',
    },
    query: `
    select
      cloud,
      resource_type,
      name,
      account,
      formatDateTime(expiration_date, '%Y-%m-%d') as date,
      tags
    from (
      ${baseQuery}
    )
    order by date
    `,
  };
};

const serverlessFunctionsRuntimesEmptyQuery = `
    SELECT
      '' as cloud,
      '' as account,
      '' as resource_type,
      '' as name,
      '' as runtime,
      '' as status,
      now() as support_ends,
      now() as expiration_date,
      '' as tags
    LIMIT 0
  `;

const getServerlessFunctionsRuntimesQuery = (tables: string[]) => {
  const tableToSelect = [
    {
      select: `_cq_cloud, _cq_account, _cq_account_name, _cq_name, _cq_id, 'aws_lambda_functions' as resource_type, tags, JSONExtractString(configuration, 'Runtime') AS runtime from aws_lambda_functions`,
      table: 'aws_lambda_functions',
    },
    {
      select: `_cq_cloud, _cq_account, _cq_account_name, _cq_name, _cq_id, 'gcp_functions_functions' as resource_type, tags, runtime FROM gcp_functions_functions`,
      table: 'gcp_functions_functions',
    },
    {
      select: `_cq_cloud, _cq_account, _cq_account_name, _cq_name, _cq_id, 'gcp_functionsv2_functions' as resource_type, tags, JSONExtractString(build_config, 'runtime') AS runtime FROM gcp_functionsv2_functions`,
      table: 'gcp_functionsv2_functions',
    },
    {
      select: `_cq_cloud, _cq_account, _cq_account_name, _cq_name, _cq_id, 'azure_appservice_web_apps' as resource_type, tags, JSONExtractString(JSONExtractRaw(properties, 'siteConfig'), 'linuxFxVersion') AS runtime FROM azure_appservice_web_apps`,
      table: 'azure_appservice_web_apps',
    },
  ];

  const filteredTableToSelect = tableToSelect.filter((t) => tables.includes(t.table));
  if (filteredTableToSelect.length === 0) {
    return serverlessFunctionsRuntimesEmptyQuery;
  }

  const resourceTypeLabelsQuery = `
    WITH resource_type_labels AS (
      SELECT resource_type_label, resource_type FROM cloud_assets
      WHERE resource_type IN (${filteredTableToSelect.map((t) => `'${t.table}'`).join(', ')})
      GROUP BY resource_type_label, resource_type
    )
  `;

  const functionConfigurationsQuery = `
    function_configurations AS (
        ${filteredTableToSelect.map((t) => `SELECT ${t.select}`).join(' UNION DISTINCT ')}
    )
  `;

  const fullQuery = `
    ${resourceTypeLabelsQuery},
    ${functionConfigurationsQuery}
    SELECT
      c._cq_cloud as cloud,
      COALESCE(NULLIF(c._cq_account_name, ''), c._cq_account) as account,
      r.resource_type_label as resource_type,
      c._cq_name as name,
      c.runtime,
      formatDateTime(eol.support_until, '%Y-%m-%d') AS support_ends,
      formatDateTime(eol.eol_since, '%Y-%m-%d') AS expiration_date,
      multiIf(
          eol.eol = true OR eol.support_until < now(), 'red',
          eol.support_until < now() + toIntervalMonth(9), 'yellow',
          'green'
      ) AS status,
      c.tags as tags,
      lower(concat(
          coalesce(cloud, ''),
          coalesce(account, ''),
          coalesce(resource_type, ''),
          coalesce(name, ''),
          coalesce(tags, '')
      )) as search_string
    FROM function_configurations c
    INNER JOIN resource_type_labels r ON r.resource_type = c.resource_type
    INNER JOIN endoflife_products eol ON concat(eol.product, eol.cycle) = c.runtime
    WHERE 1=1 AND expiration_date <= '?'
    `;

  return fullQuery;
};

const serverlessFunctionsRuntimesItem = (baseQuery: string): ReportYamlItem => {
  return {
    title: 'Serverless Functions Runtimes',
    display: {
      type: 'table',
    },
    query: `
    select
      cloud,
      resource_type,
      name,
      account,
      runtime,
      support_ends,
      expiration_date,
      status,
      tags
    from (
      ${baseQuery}
    )
    order by name
    `,
  };
};

const kubernetesClustersRuntimesEmptyQuery = `
  SELECT
    '' as cloud,
    '' as account,
    '' as resource_type,
    '' as name,
    '' as kubernetes_version,
    now() as support_ends,
    now() as expiration_date,
    '' as tags,
    '' as status
  LIMIT 0
  `;

const getKubernetesClustersRuntimesQuery = (tables: string[]) => {
  const tableToSelect = [
    {
      dependencies: ['aws_eks_cluster_versions'],
      select: `c._cq_cloud as cloud, c._cq_account as account, c._cq_account_name as account_name, c._cq_name as name, c.tags as tags, 'aws_eks_clusters' AS resource_type, v.kubernetes_patch_version AS kubernetes_version FROM aws_eks_clusters c JOIN aws_eks_cluster_versions v ON c.arn = v.cluster_arn`,
      table: 'aws_eks_clusters',
    },
    {
      dependencies: [],
      select: `_cq_cloud as cloud, _cq_account as account, _cq_account_name as account_name, _cq_name as name, tags, 'gcp_container_clusters' AS resource_type, current_master_version AS kubernetes_version FROM gcp_container_clusters`,
      table: 'gcp_container_clusters',
    },
    {
      dependencies: [],
      select: `_cq_cloud as cloud, _cq_account as account, _cq_account_name as account_name, _cq_name as name, tags, 'azure_containerservice_managed_clusters' AS resource_type, JSONExtractString(properties, 'currentKubernetesVersion') AS kubernetes_version FROM azure_containerservice_managed_clusters`,
      table: 'azure_containerservice_managed_clusters',
    },
  ];

  const filteredTableToSelect = tableToSelect.filter(
    (t) => tables.includes(t.table) && t.dependencies.every((d) => tables.includes(d)),
  );
  if (filteredTableToSelect.length === 0) {
    return kubernetesClustersRuntimesEmptyQuery;
  }

  const resourceTypeLabelsQuery = `
    WITH resource_type_labels AS (
      SELECT resource_type_label, resource_type FROM cloud_assets
      WHERE resource_type IN (${filteredTableToSelect.map((t) => `'${t.table}'`).join(', ')})
      GROUP BY resource_type_label, resource_type
    )
  `;

  const clustersQuery = `
    clusters AS (
      ${filteredTableToSelect.map((t) => `SELECT ${t.select}`).join(' UNION ALL ')}
    )
  `;

  const fullQuery = `
    ${resourceTypeLabelsQuery},
    ${clustersQuery}
    SELECT
      c.cloud as cloud,
      r.resource_type_label as resource_type,
      c.name as name,
      COALESCE(NULLIF(c.account_name, ''), c.account) as account,
      c.tags as tags,
      c.kubernetes_version as kubernetes_version,
      formatDateTime(eol.support_until, '%Y-%m-%d') AS support_ends,
      formatDateTime(eol.eol_since, '%Y-%m-%d') AS expiration_date,
      multiIf(
        eol.eol = true OR eol.support_until < now(), 'red',
        eol.support_until < now() + toIntervalMonth(9), 'yellow',
        'green'
      ) AS status,
      lower(concat(
        coalesce(c.name, ''),
        coalesce(c.account, ''),
        coalesce(c.cloud, ''),
        coalesce(c.resource_type, ''),
        coalesce(status, ''),
        coalesce(c.kubernetes_version, ''),
        coalesce(c.tags, '')
      )) as search_string
    FROM clusters c
    INNER JOIN resource_type_labels r ON r.resource_type = c.resource_type
    INNER JOIN (SELECT * FROM endoflife_products WHERE product = 'kubernetes') AS eol ON eol.cycle = extract(c.kubernetes_version, '^(\\d+\\.\\d+)')
    WHERE 1=1 AND expiration_date <= '?'
  `;

  return fullQuery;
};

const kubernetesClustersRuntimesItem = (baseQuery: string): ReportYamlItem => {
  return {
    title: 'Kubernetes Clusters Runtimes',
    display: {
      type: 'table',
    },
    query: `
      select cloud, resource_type, name, account, kubernetes_version, support_ends, expiration_date, status, tags
      from (${baseQuery})
      order by name
    `,
  };
};

export async function getReportItems() {
  const data = await fetchAllPages((page) => platformListTables({ page, per_page: 1000 }));
  const allTables = data?.data?.items?.map((item: { name: string }) => item.name) ?? [];
  const expiredCertificatesQuery = getExpiredCertificatesQuery(allTables);
  const serverlessFunctionsRuntimesQuery = getServerlessFunctionsRuntimesQuery(allTables);
  const kubernetesClustersRuntimesQuery = getKubernetesClustersRuntimesQuery(allTables);

  const widgets: ReportYamlItem[] = [
    expiredCertificatesItem(expiredCertificatesQuery),
    serverlessFunctionsRuntimesItem(serverlessFunctionsRuntimesQuery),
    kubernetesClustersRuntimesItem(kubernetesClustersRuntimesQuery),
  ];

  return { widgets };
}
